import {strEnum} from "../../types";

/**
 * CIC-2 Tenants
 * @see https://confluence.tibco.com/pages/viewpage.action?pageId=220776670
 */
export const TCI_CIC2_TENANT = {
    "CIC1": "cic1",
    "TSC": "tsc",
    "CPS": "tsc",
    "TCI": "tci",
    "TCI_APPS": "tciapps",
    "TCLA": "tcla",
    "TAS": "tcta",
    "TCTA": "tcta",
    "TCE": "tce",
    "TCM": "tcm",
    "TCMD": "tcmd",
    "EBX": "ebx",
    "TCDS": "tcds",
    "TCS": "tcs",
    "TCAM": "tcam",
    "UCS": "ucs"
};
export const TCI_CIC2_TENANT_TYPE = strEnum([
        "CIC1",
        "TSC",
        "CPS",
        "TCI",
        "TCI_APPS",
        "TCLA",
        "TAS",
        "TCTA",
        "TCE",
        "TCM",
        "EBX",
        "TCDS",
        "TCS",
        "TCAM",
        "UCS"
    ]
);
export type TCI_CIC2_TENANT_TYPE = keyof typeof TCI_CIC2_TENANT;
export const TCI_CIC2_POD_PREFIX = "cic-tenant-tci";

export interface ITCIIntercomPattern {
    pattern: string;
    chartName: string;
    port: string;
    regex?: RegExp;
}

export const TCI_CIC2_INTERCOM_PATTERNS: ITCIIntercomPattern[] = [
    {
        pattern: ".*\/domain\b",
        chartName: `${TCI_CIC2_POD_PREFIX}-domainserver`,
        port: "7810",
    },
    {
        pattern: ".*\/orchestrator",
        chartName: `${TCI_CIC2_POD_PREFIX}-orchestrator`,
        port: "7813"
    },
    // This path is never called in WS, old dead code
    // {
    //   pattern: ".*\/appmgr"
    //   chartName: `${TCI_CIC2_POD_PREFIX}-orchestrator`
    // },
    {
        pattern: ".*\/marketplace",
        chartName: `${TCI_CIC2_POD_PREFIX}-marketplace`,
        port: "7820"
    },
    {
        pattern: ".*\/metricsserver-1",
        chartName: `${TCI_CIC2_POD_PREFIX}-metricsserver1`,
        port: "7815"
    },
    {
        pattern: ".*\/metricsserver-2",
        chartName: `${TCI_CIC2_POD_PREFIX}-metricsserver2`,
        port: "7815"
    },
    {
        pattern: ".*\/metricsserver-3",
        chartName: `${TCI_CIC2_POD_PREFIX}-metricsserver3`,
        port: "7815"
    },
    {
        pattern: ".*\/wistudio",
        chartName: `${TCI_CIC2_POD_PREFIX}-wistudio`,
        port: "7747"
    },
    {
        pattern: ".*\/apimodeler",
        chartName: `${TCI_CIC2_POD_PREFIX}-modeler`,
        port: "8888"
    },
    {
        pattern: ".*\/apimock",
        chartName: `${TCI_CIC2_POD_PREFIX}-mock`,
        port: "7002"
    },
    {
        pattern: ".*\/api-nodejs",
        chartName: `${TCI_CIC2_POD_PREFIX}-api-nodejs`,
        port: "8080"
    },
    {
        pattern: ".*\/liveapps",
        chartName: `${TCI_CIC2_POD_PREFIX}-liveapps`,
        port: "3125"
    },
    {
        pattern: ".*\/bwstudio",
        chartName: `${TCI_CIC2_POD_PREFIX}-bw-studio`,
        port: "25819"
    },
    {
        pattern: ".*\/scribe",
        chartName: `${TCI_CIC2_POD_PREFIX}-scribe`,
        port: "3123"
    },
    {
        pattern: ".*\/masheryapiproxy",
        chartName: `${TCI_CIC2_POD_PREFIX}-mashery`,
        port: "7909"
    },
    {
        pattern: ".*\/elasticproxy",
        chartName: `${TCI_CIC2_POD_PREFIX}-log-proxy`,
        port: "8003"
    },
    {
      pattern: ".*\/tciucs",
      chartName: `${TCI_CIC2_POD_PREFIX}-ucs-ui`,
      port: "3126"
  },
];

/**
 * The purpose of this class is to quickly match a
 * pattern out of list of patterns e.g.
 * http://<intercom url:port>/path and replace only the matched
 * part => http://<intercom url:port>/path with something like
 * http://cic-tenant-tci-domainserver.local-tibco-tci.svc.cluster.local:7810/<unmatched part of the path>
 * or else return the input url.
 * Note ".*\/domainserver" should match "http://<intercom:port>/domainserver"
 * this is intended to be used inside TCIHttp client api
 */
export class TCIIntercomPatternMatcher {
    constructor(patterns: ITCIIntercomPattern[]) {
        patterns.forEach(item => {
            const obj = Object.assign({}, item);
            const rgxstr = `(?:${item.pattern})`;
            obj.regex = new RegExp(rgxstr);
            this.intercom_patterns.push(obj);
        });
    }

    private static instance;
    private intercom_patterns: ITCIIntercomPattern[] = [];

    public static getInstance(patterns: ITCIIntercomPattern[]): TCIIntercomPatternMatcher {
        if (!TCIIntercomPatternMatcher.instance) {
            TCIIntercomPatternMatcher.instance = new TCIIntercomPatternMatcher(patterns);
        }
        return TCIIntercomPatternMatcher.instance;
    }

    public getCIC2IntercomUrl(url: string, namespace: string): string {
        for (const icpattern of this.intercom_patterns) {
            if (icpattern.regex.test(url)) {
                return url.replace(icpattern.regex, (matched) => `http://${icpattern.chartName}.${namespace}.svc.cluster.local:${icpattern.port}`);
            }
        }
        return url;
    }

    public getPatterns(): ITCIIntercomPattern[] {
        return this.intercom_patterns;
    }
}


